import React, { useState, useRef } from "react";
import env from "@beam-australia/react-env";
import { atom, useAtom } from "jotai";
import { forgotPasswordState } from "../../../states/forgotPasswordState";

import { loadingState } from "../../../states/loadingState";

import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useForm } from "react-hook-form";
import { Button } from "primereact/button";
import { InputOtp } from "primereact/inputotp";
import useApi from "../../../hooks/useApi";
import "./resetPassword.css";
import { Toast } from "primereact/toast";
import { useGoogleReCaptcha } from "react-google-recaptcha-v3";

const ResetPasswordStep2_checkRecovery = ({ settings }) => {
  const { t } = useTranslation();
  const api = useApi();
  const [isLoading, setIsLoading] = useAtom(loadingState);
  const [captchaToken, setCaptchaToken] = useState(null);
  const navigate = useNavigate();
  const toast = useRef(null);
  const [key, setKey] = useState();

  const setForgotPassword = useAtom(forgotPasswordState);
  const forgotPassword = useAtom(forgotPasswordState);

  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm({
    defaultValues: {
      email: forgotPassword.email,
      key: "",
    },
  });

  const { executeRecaptcha } = useGoogleReCaptcha();

  const onSubmit = async (data) => {
    if (!executeRecaptcha) {
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: "reCAPTCHA no disponible",
        life: 3000,
      });
      return;
    }

    const token = await executeRecaptcha("submit");

    if (!token) {
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: "Error al generar el reCAPTCHA",
        life: 3000,
      });
      return;
    }

    setCaptchaToken(token);
    setIsLoading(true);

    try {
      data.key = key;

      const response = await api.post(
        `${env("API_URL")}/base/auth/checkrecovery`,
        { ...data, captchaToken: token }
      );

      console.log(response);
      if (response.data.isValid) {
        toast.current.show({
          severity: "success",
          summary: t("forms.messages.titles.success"),
          detail: t("forms.messages.operation.success"),
          life: 3000,
        });

        setForgotPassword((prevState) => ({
          ...prevState,
          key: key,
        }));

        navigate("/ResetPasswordStep3_recovery");
      } else {
        toast.current.show({
          severity: "error",
          summary: t("forms.messages.titles.error"),
          detail: t("forms.messages.operation.error"),
          life: 3000,
        });
      }
    } catch (error) {
      toast.current.show({
        severity: "error",
        summary: t("forms.messages.titles.error"),
        detail: t("forms.messages.operation.error"),
        life: 3000,
      });
    }

    setIsLoading(false);
  };

  const getFormErrorMessage = (error) => {
    return error && <small className="p-error">{error.message}</small>;
  };

  return (
    <React.Fragment>
      <Toast ref={toast} />
      <div className="flex justify-content-center align-items-center h-screen">
        <div className="flex flex-column  justify-content-center align-items-center p-4 border-1 border-400">
          <div>
            <p className="inputHelpText inputHelpText_small p-4">
              Se ha enviado un código de verificación al correo electrónico{" "}
              {forgotPassword.email}.
            </p>
            <p className="inputHelpText inputHelpText_small p-4">
              Ingresa el código de verificación que te hemos enviado a tu
              correo.
            </p>
          </div>
          <form onSubmit={handleSubmit(onSubmit)} className="p-fluid">
            <div className="card flex justify-content-center">
              <InputOtp
                className="input_otp"
                value={key}
                onChange={(e) => setKey(e.value)}
                length={6}
                integerOnly
              />
            </div>

            <Button
              label={t("Confirmar código")}
              className="button_big"
              loading={isLoading}
            />

            <p
              className="inputHelpText inputHelpText_small"
              style={{ textAlign: "center", paddingTop: "20px" }}
            >
              Textum es un servicio exclusivo para el personal de nuestras
              empresas asociadas.
            </p>
          </form>
        </div>
      </div>
    </React.Fragment>
  );
};

export default ResetPasswordStep2_checkRecovery;
